module.exports = __webpack_public_path__ + "static/img/disfinect.53b97453.png";